<div class="poll-container {{poll-container-class}}">
  <div class="row">
    <div class="question_text" tabindex="0">{{#if translate}}{{t text}}{{else}}{{text}}{{/if}}</div>
    {{#if subtext}}
      <div class="subtext">{{#if translate}}{{t subtext}}{{else}}{{subtext}}{{/if}}</div>
    {{/if}}
  </div>
  <div class="row">
    {{#if image_path}}
    <div class="question_image">
      <img src="{{assetPath image_path}}" />
    </div>
    {{/if}}
    <div class="btn-group-vertical question_block" data-toggle="buttons" id="question">
      {{#each answers}}

        <label class="btn btn-default poll_answer {{#if selected}}active{{/if}} {{#if ../multiple}}checkbox{{else}}radio{{/if}}" tabindex="0" {{#unless percent}}role="button"{{/unless}}>
          {{#if badge_class}}
            <div class="{{badge_class}}">{{badge_value}}</div>
          {{/if}}
          <label for="{{id}}">{{#if ../translate}}{{t text}}{{else}}{{text}}{{/if}}</label>


          {{#if collect_user_supplied_text}}
            <input class="user-supplied-text" aria-label="Answer. {{text}}. When finished, tab to the next button and hit enter to complete answer." type="text" id="{{id}}" name="question_{{../id}}" value="{{user_supplied_text}}" data-question-id="{{../id}}"  />
            <button aria-label="Answer submit button." class="btn btn-default inline_complete" style="display:none;"><i class="fa fa-check"></i></button>
          {{else}}
            <input type="{{#if ../multiple}}checkbox{{else}}radio{{/if}}" id="{{id}}" name="question_{{../id}}" data-question-id="{{../id}}" value="{{id}}"/>
          {{/if}}

          {{#if percent }}
              {{#unless ../hide_results}}
                  <div class="result">
                      <span class="poll-id" aria-hidden="true">{{id}}</span>
                      <div class="poll progress">
                        <div class="progress-bar" style="width:{{percent}}%;" role="progressbar" aria-valuenow="{{percent}}" aria-valuemin="0" aria-valuemax="100" {{#if ../inline_percentage}}aria-hidden="true"{{/if}}>
                        </div>
                        {{#if ../inline_percentage}}<span class="percentage percentage-inline" data-count={{count}}>{{percent}}%</span>{{/if}}
                      </div>
                      {{#unless ../inline_percentage}}<div class="percentage">{{percent}}%</div>{{/unless}}
                  </div>
              {{/unless}}
          {{/if}}
        </label>
      {{/each}}
      {{#if multiple}}
      <button class="btn btn-default poll_complete">{{t button_text}}</button>
      {{/if}}
    </div>
    {{#if total}}
        {{#unless hide_results}}
            <div class="total">
                <span>{{total}}<span>
            </div>
        {{/unless}}
    {{/if}}
  </div>
</div>
